
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': 'Бақылау тақтасын жасау',
	'dashboard': 'Бақылау тақтасы',
	'dashboardTemplate': 'Бақылау тақтасының үлгісі',
	'createAV': 'Жасау',
	'createAvEditNameLabel': '1. Көрініске атау беру',
	'createAvSelectTemplateLabel': '2. Үлгіні таңдау',
	'tabLayoutLabel': 'Қойынды үлгісі',
	'infographicsLayoutLabel': 'Инфографика үлгісі',
	'singlePageLayoutLabel': 'Бір бет үлгісі',
	'customLayoutLabel': 'Теңшелетін үлгі',
	'freeformTemplate': 'Иілгіш нысан',
	'freeformTemplateDesc': 'Иілгіш нысан көрнекі бейнелері көрініс ішінде өлшеу және орналастыру түрінде, экран өлшемін елеместен пайда болады. Өзге орналастырулар ішінде, көрнекі бейнелер өлшемі және орналасуы экранға сәйкес реттеледі.',
	'NoTemplate': 'Еркін пішім',
	'Template1': 'Бос',
	'Template2': '2-дегі 1-тақырып',
	'Template3': '1 үстіндегі 2',
	'Template4': '1 үстіндегі 4',
	'Template5': '2-дегі 1 төменгі деректеме',
	'Template6': '1 үстіндегі 1-дің жанындағы 3',
	'Template7': '1 үстіндегі 3-тің жанындағы 4',
	'Template8': '2-дегі 3 жанындағы 2',
	'Template9': '2 бойынша 2',
	'Template10': '1 арқылы 2 жанындағы 2 бойынша 2 үстіндегі 1',
	'Template11': '3 арқылы 1 үстіндегі 1-дегі 2',
	'Template12': '2 үстіндегі 1 жанындағы 1-дегі 2',
	'Template13': 'Бір жанындағы 1 бойынша 2-дегі 1 арқылы 4',
	'Template22': '1 2-ден 2-ге артық',
	'Template14': '1 жанында 1',
	'Template15': '1-дің жанында 1-ден 1',
	'Template16': '1-дің жанында 1-ден артық 1',
	'Template17': '1-дің үстіндегі 1 жанында 1-дің үстіндегі 1',
	'Template18': '1-дің жанында 1-ден 1',
	'Template19': '1-дің жанындағы 2-нің үстідегі 1',
	'Template20': '1 2-ден 1-ге көп',
	'Template21': '1-ден 1-ден артық 2-ден 1-ге артық',
	'Template23': 'Тастау аймағымен бос орын',
	'Infographics1': 'Бос',
	'Infographics2': '4 жол',
	'Infographics3': 'тақырыптары бар 4 жол',
	'Infographics4': '2-дегі 4',
	'Infographics5': 'Үлкен топ 2 санын 2 арқылы көрсетеді',
	'Infographics6': '4 тік бос орынмен 2',
	'Infographics7': '4 шахматты орынмен 2',
	'Infographics8': 'Теннис алаңы',
	'Infographics9': '4-тегі 3',
	'Infographics10': '8-дегі 4',
	'createAvDashboardLabel': 'Орналасу',
	'dashboard_template_save_success': 'Бақылау тақтасындағы үлгі сақталды.',
	'dashboard_template_prefix': 'Үлгі: "%{name}"',
	'dashboard_template_filters_removed': 'Кенептегі сүзгілер алынып тасталды.',
	'createAvTabLabel': 'Қойындылары бар',
	'createAvInfographicsLabel': 'Инфографика',
	'createAvSinglepageLabel': 'Бір парақ',
	'createAvCustomLabel': 'Теңшелетін',
	'loadMoreLabel': 'Қосымша еңгізу...',
	'backLabel': 'Қайту',
	'addSourceLabel': 'Қор көзін қосу',
	'pinLabel': 'Қыстыру',
	'errorLoadingDataSetMetaData': 'Метадеректерді оқу кезінде қате орын алды.',
	'errorLoadingDataSets': 'Дерек жиындарының тізімін жүктеу кезінде қателік пайда болды',
	'errorLoadingDataSet': '"%{datasetName}" деректер жиынтығының метадеректері жүктелмеді. Толығырақ мәлімет үшін әкімшіңізге хабарласыңыз.',
	'okButton': 'OK',
	'createButton': 'Жасау',
	'cancelButton': 'Болдырмау',
	'copyButton': 'Көшіру',
	'selectTemplateLabel': 'Үлгіні таңдау',
	'createBoardTitle': 'Бақылау тақтасын жасаңыз',
	'createBoardSubtitle': 'Бақылау тақтасына үлгіні таңдаңыз',
	'noSourcesSelectedLabel': 'Еш көздер таңдалмаған',
	'find_label': 'Табу',
	'noDashboardFound': 'Тақта шығарып алынбады. Енді мұнда жоқ немесе оны көру үшін артықшылықтарыңыз жеткіліксіз.',
	'errorLabel': 'Қате',
	'defaultName': 'Жаңа бақылау тақтасы',
	'noDashboardCapability': 'Тақтаның бағдарламасын іске қосу мүмкіндігіңіз жоқ',
	'noDashboardPermission': 'Бұл құралдар тақтасын көру үшін жеткілікті артықшылықтарыңыз жоқ',
	'sourceNotFound': 'Біз көрнекілендіруді жүктей алмаймыз, себебі "%{sourceName}"-мен байланыстырылған көзі қол жетімді емес',
	'cmDuplicateName': 'Бұл аты бар элемент бұрыннан бар. Өзге атты сынап көріңіз',
	'cmEmptySelection': 'Құралдар тақтасы жойылған. Жаңа жиынтық тақтасы ретінде сақтауға тырысыңыз.',
	'propTheme': 'Көрнекі тақырып',
	'legacyThemeLabel': 'Бұрынғы',
	'carbonGrey10Label': 'Carbon X Light',
	'carbonGrey100Label': 'Carbon X Dark',
	'titleTextLabel': 'Тақырып',
	'titleSmallTextLabel': 'Кішкене тақырып',
	'subtitleTextLabel': 'Тақырыпша',
	'bodyTextLabel': 'Негізгі мәтін',
	'bodySmallTextLabel': 'Кіші мәтін',
	'captionTextLabel': 'Тақырып',
	'quoteTextLabel': 'Дәйексөз',
	'quoteSmallTextLabel': 'Кіші Дәйексөз',
	'responsiveTextLabel': 'Автоөлшем',
	'mediaWidgetLabel': 'Мультимедиа',
	'webpageWidgetLabel': 'Веб-бет',
	'imageWidgetLabel': 'Кескін',
	'textWidgetLabel': 'Мәтін',
	'notebookWidgetLabel': 'Notebook',
	'multipurposeWidgetLabel': 'Көп_мақсатты',
	'textPlaceHolder': 'Мәтінді өңдеу үшін басыңыз',
	'titlePlaceHolder': 'Тақырыпты өңдеу үшін басыңыз',
	'toggleEditModeLabel': 'Өңдеуге ауыстырыңыз',
	'togglePreviewModeLabel': 'Алдын ала қарауға ауыстырыңыз',
	'editDashboardCoachMarkTitle': 'Бақылау тақтасын өңдеу',
	'editDashboardCoachMarkContents': 'Бақылау тақтасын өңдеу үшін қаламсап белгішесін басыңыз.',
	'addDataCoachMarkTitle': 'Деректер қосу',
	'addDataDashboardCoachMarkContents': 'Деректерді бақылау тақтасына деректер тақтасынан сүйреп апару.',
	'pageSelectWarning': 'Қойындыны таңдаңыз.',
	'screenshot_label': 'Бақылау тақтасы %{title}',
	'screenshot_label_tab': '%{title} бақылау тақтасының %{tabName} қойындысы',
	'dataAssetPropertiesLabel': 'Визуалдау сипаттары',
	'modelFilter': 'Сүзгі',
	'invertSelectionToolTip': 'Сүзгі таңдауын оралту',
	'clearFilterValueToolTip': 'Сүзгі мәндерін тазарту',
	'invertFilterSelection': 'Оралту',
	'clearTextFilterValue': 'Тазалау',
	'filterConditionLabel': 'Сүзгілеу шарты',
	'applyFilter': 'Сүзгі қолдану',
	'itemCountText': '%{itemCount} Таңдалған элемент (-тер)',
	'itemExcludeCountText': '%{itemCount} Элемент (тер) алып тасталды',
	'moreMembers': 'Қосымша көрсету...',
	'searchHierarchyMembers': 'Мүшелерді табу үшін іздеуді пайдаланыңыз...',
	'propHideEmpty': 'Босты жасыру',
	'propColorOrder': 'Түрлі-түсті тапсырыс',
	'propElementColor': 'Көрнекі бейне элемент түсі',
	'propLineColor': 'Сызық түсі',
	'propLineAndSymbolColor': 'Сызық және нышан түсі',
	'propColumnColor': 'Баған түсі',
	'propBarColor': 'Жолақ түсі',
	'propWordColor': 'Сөз түсі',
	'propAreaColor': 'Аймақ түсі',
	'propRadialbarColor': 'Радиалды жолық түсі',
	'propColorPalettes': 'Түс бояғыштары',
	'propDashboardColorPalette': 'Ағымдағы бақылау тақтасының бояғышы',
	'propNewDashboardPaletteLabel': 'Теңшелетін бақылау тақтасының палитрасын жасаңыз',
	'propDashboardChangePaletteLink': 'Бақылау тақтасының бояғышын өзгерту',
	'propHideLeafNode': 'Бастау жапсырмаларды жасыру',
	'propOpacity': 'Бұлыңғырлық',
	'propOpacityDescription': 'Нысанды күңгірт немесе одан кем жасаңыз. 0 және 100 орталығында мәнді енгізіңіс',
	'addATab': 'Жаңа қойындыны қосу',
	'propFredIsRed': 'Түстердің дәйектілігі',
	'areaChartCaption': 'Аймақ',
	'areaChartDataSlot_categoriesLabel': 'Ось белгісі',
	'areaChartDataSlot_valuesLabel': 'Мән',
	'areaChartProp_colorPaletteLabel': 'Түс бояғыштары',
	'areaChartProp_lineColorLabel': 'Аймақ түсі',
	'areaChartProp_interpolationLabel': 'Тегіс жолдар',
	'areaChartProp_interpolationDescription': 'Деректер нүктесін қосатын сызық доғаланған.',
	'areaChartProp_hideGridLinesLabel': 'Тор сызықтарды жасыру',
	'areaChartProp_hideGridLinesDescription': 'Тор сызықтарды жасыру',
	'areaChartProp_hideAxisTitleLabelsLabel': 'Ось тақырыбы белгілерін жасыру',
	'areaChartProp_hideAxisTitleLabelsDescription': 'Біліктер үшін тақырыптарды жасырыңыз.',
	'areaChartProp_maintainAxisScalesLabel': 'Білік өлшемін сақтап қалу',
	'areaChartProp_maintainAxisScalesDescription': 'Біліктерде ең кіші және ең үлкен мәнін әрдайым көрсетіңіз.',
	'areaChartProp_suppressZerosLabel': 'Босты жасыру',
	'areaChartProp_suppressZerosDescription': 'Біріктірілген мәндері жоқ санаттарды жасырыңыз.',
	'barChartCaption': 'Тақта',
	'barChartDataSlot_categoriesLabel': 'Ось белгісі',
	'barChartDataSlot_valuesLabel': 'Мән',
	'barChartProp_colorPaletteLabel': 'Түс бояғыштары',
	'barChartProp_elementColorLabel': 'Жолақ түсі',
	'barChartProp_hideGridLinesLabel': 'Тор сызықтарды жасыру',
	'barChartProp_hideGridLinesDescription': 'Тор сызықтарды жасыру',
	'barChartProp_hideAxisTitleLabelsLabel': 'Ось тақырыбы белгілерін жасыру',
	'barChartProp_hideAxisTitleLabelsDescription': 'Біліктер үшін тақырыптарды жасырыңыз.',
	'barChartProp_maintainAxisScalesLabel': 'Білік өлшемін сақтап қалу',
	'barChartProp_maintainAxisScalesDescription': 'Біліктерде ең кіші және ең үлкен мәнін әрдайым көрсетіңіз.',
	'barChartProp_suppressZerosLabel': 'Босты жасыру',
	'barChartProp_suppressZerosDescription': 'Біріктірілген мәндері жоқ санаттарды жасырыңыз.',
	'columnChartCaption': 'Баған',
	'columnChartDataSlot_categoriesLabel': 'Ось белгісі',
	'columnChartDataSlot_valuesLabel': 'Мән',
	'columnChartProp_colorPaletteLabel': 'Түс бояғыштары',
	'columnChartProp_elementColorLabel': 'Баған түсі',
	'columnChartProp_hideGridLinesLabel': 'Тор сызықтарды жасыру',
	'columnChartProp_hideGridLinesDescription': 'Тор сызықтарды жасыру',
	'columnChartProp_hideAxisTitleLabelsLabel': 'Ось тақырыбы белгілерін жасыру',
	'columnChartProp_hideAxisTitleLabelsDescription': 'Біліктер үшін тақырыптарды жасырыңыз.',
	'columnChartProp_maintainAxisScalesLabel': 'Білік өлшемін сақтап қалу',
	'columnChartProp_maintainAxisScalesDescription': 'Біліктерде ең кіші және ең үлкен мәнін әрдайым көрсетіңіз.',
	'columnChartProp_suppressZerosLabel': 'Босты жасыру',
	'columnChartProp_suppressZerosDescription': 'Біріктірілген мәндері жоқ санаттарды жасырыңыз.',
	'bubbleChartCaption': 'Көпіршікті',
	'bubbleChartDataSlot_xAxisLabel': 'Көлденең ось',
	'bubbleChartDataSlot_yAxisLabel': 'Тік ось',
	'bubbleChartDataSlot_sizeLabel': 'Өлшем арқылы',
	'bubbleChartDataSlot_colorLabel': 'Түс арқылы',
	'bubbleChartProp_colorPaletteLabel': 'Түс бояғыштары',
	'bubbleChartProp_hideGridLinesLabel': 'Тор сызықтарды жасыру',
	'bubbleChartProp_hideGridLinesDescription': 'Тор сызықтарды жасыру',
	'bubbleChartProp_hideAxisTitleLabelsLabel': 'Ось тақырыбы белгілерін жасыру',
	'bubbleChartProp_hideAxisTitleLabelsDescription': 'Біліктер үшін тақырыптарды жасырыңыз.',
	'bubbleChartProp_maintainAxisScalesLabel': 'Білік өлшемін сақтап қалу',
	'bubbleChartProp_maintainAxisScalesDescription': 'Біліктерде ең кіші және ең үлкен мәнін әрдайым көрсетіңіз.',
	'bubbleChartProp_hideLegendLabel': 'Мәндік белгілерді жасыру',
	'bubbleChartProp_hideLegendDescription': 'Бұл мәнді белгілерді жасырыңыз.',
	'bubbleChartProp_legendPositionLabel': 'Мәнді белгілер орналасуы',
	'lineChartCaption': 'Жол',
	'lineChartDataSlot_categoriesLabel': 'Ось белгісі',
	'lineChartDataSlot_valuesLabel': 'Мән',
	'lineChartProp_colorPaletteLabel': 'Түс бояғыштары',
	'lineChartProp_lineColorLabel': 'Сызық және нышан түсі',
	'lineChartProp_symbolShapeLabel': 'Нышан кескіні',
	'lineChartProp_hideSymbolsLabel': 'Нышандарды Жасыру',
	'lineChartProp_hideSymbolsDescription': 'Нышандарды жасыру',
	'lineChartProp_hideDataLinesLabel': 'Сызық(тар)ды жасыру',
	'lineChartProp_hideDataLinesDescription': 'Сызық(тар)ды жасыру',
	'lineChartProp_interpolationLabel': 'Тегіс жолдар',
	'lineChartProp_interpolationDescription': 'Деректер нүктесін қосатын сызық доғаланған.',
	'lineChartProp_hideGridLinesLabel': 'Тор сызықтарды жасыру',
	'lineChartProp_hideGridLinesDescription': 'Тор сызықтарды жасыру',
	'lineChartProp_hideAxisTitleLabelsLabel': 'Ось тақырыбы белгілерін жасыру',
	'lineChartProp_hideAxisTitleLabelsDescription': 'Біліктер үшін тақырыптарды жасырыңыз.',
	'lineChartProp_maintainAxisScalesLabel': 'Білік өлшемін сақтап қалу',
	'lineChartProp_maintainAxisScalesDescription': 'Біліктерде ең кіші және ең үлкен мәнін әрдайым көрсетіңіз.',
	'lineChartProp_suppressZerosLabel': 'Босты жасыру',
	'lineChartProp_suppressZerosDescription': 'Біріктірілген мәндері жоқ санаттарды жасырыңыз.',
	'packedBubbleChart1CatCaption': 'Бумаланған көпіршік',
	'packedBubbleChart1CatDataSlot_categoriesLabel': 'Санаттар',
	'packedBubbleChart1CatDataSlot_sizeLabel': 'Өлшем арқылы',
	'packedBubbleChart1CatProp_colorPaletteLabel': 'Түс бояғыштары',
	'packedBubbleChart1CatProp_elementColorLabel': 'Көпіршік түсі',
	'packedBubbleChart1CatProp_hideLabelLabel': 'Белгіні жасыру',
	'packedBubbleChart1CatProp_hideValueLabel': 'Мәнді жасыру',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': 'Білік өлшемін сақтап қалу',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': 'Біліктерде ең кіші және ең үлкен мәнін әрдайым көрсетіңіз.',
	'packedBubbleChart1CatProp_suppressZerosLabel': 'Босты жасыру',
	'packedBubbleChart1CatProp_suppressZerosDescription': 'Біріктірілген мәндері жоқ санаттарды жасырыңыз.',
	'heatChartCaption': 'Қатынасу жиілігі',
	'heatChartDataSlot_valuesLabel': 'Қатынасу жиілігі арқылы',
	'heatChartDataSlot_xAxisLabel': 'Көлденең ось',
	'heatChartDataSlot_yAxisLabel': 'Тік ось',
	'heatChartProp_colorPaletteLabel': 'Түс бояғыштары',
	'heatChartProp_heatScalePaletteLabel': 'Түрлі-түсті тапсырыс',
	'heatChartProp_hideAxisTitleLabelsLabel': 'Ось тақырыбы белгілерін жасыру',
	'heatChartProp_hideAxisTitleLabelsDescription': 'Біліктер үшін тақырыптарды жасырыңыз.',
	'heatChartProp_maintainAxisScalesLabel': 'Білік өлшемін сақтап қалу',
	'heatChartProp_maintainAxisScalesDescription': 'Біліктерде ең кіші және ең үлкен мәнін әрдайым көрсетіңіз.',
	'heatChartProp_suppressZerosLabel': 'Босты жасыру',
	'heatChartProp_suppressZerosDescription': 'Біріктірілген мәндері жоқ санаттарды жасырыңыз.',
	'heatChartProp_hideLegendLabel': 'Мәндік белгілерді жасыру',
	'heatChartProp_hideLegendDescription': 'Бұл мәнді белгілерді жасырыңыз.',
	'heatChartProp_legendPositionLabel': 'Мәнді белгілер орналасуы',
	'pieChartCaption': 'Дөңгелек',
	'pieChartDataSlot_categoriesLabel': 'Санаттар',
	'pieChartDataSlot_valuesLabel': 'Мән',
	'pieChartProp_colorPaletteLabel': 'Түс бояғыштары',
	'pieChartProp_hideRadialValueLabel': 'Мәнді жасыру',
	'pieChartProp_pieAsDonutLabel': 'Сақина диаграммасы ретінде көрсету',
	'pieChartProp_pieAsDonutDescription': 'Сақина диаграммасы ретінде көрсету',
	'pieChartProp_suppressZerosLabel': 'Босты жасыру',
	'pieChartProp_suppressZerosDescription': 'Біріктірілген мәндері жоқ санаттарды жасырыңыз.',
	'pieChartProp_hideLegendLabel': 'Мәндік белгілерді жасыру',
	'pieChartProp_hideLegendDescription': 'Бұл мәнді белгілерді жасырыңыз.',
	'pieChartProp_legendPositionLabel': 'Мәнді белгілер орналасуы',
	'map1measureCaption': 'Карта',
	'map1measureDataSlot_categoriesLabel': 'Аймақтар',
	'map1measureDataSlot_valuesLabel': 'Аймақ қатынасу жиілігі',
	'map1measureProp_colorPaletteLabel': 'Түс бояғыштары',
	'map1measureProp_heatScalePaletteLabel': 'Түрлі-түсті тапсырыс',
	'map1measureProp_maintainAxisScalesLabel': 'Білік өлшемін сақтап қалу',
	'map1measureProp_maintainAxisScalesDescription': 'Біліктерде ең кіші және ең үлкен мәнін әрдайым көрсетіңіз.',
	'map1measureProp_suppressZerosLabel': 'Босты жасыру',
	'map1measureProp_suppressZerosDescription': 'Біріктірілген мәндері жоқ санаттарды жасырыңыз.',
	'map1measureProp_hideLegendLabel': 'Мәндік белгілерді жасыру',
	'map1measureProp_hideLegendDescription': 'Бұл мәнді белгілерді жасырыңыз.',
	'map1measureProp_legendPositionLabel': 'Мәнді белгілер орналасуы',
	'radialChartCaption': 'Радиалды',
	'radialChartDataSlot_categoriesLabel': 'Санаттар',
	'radialChartDataSlot_valuesLabel': 'Мән',
	'radialChartProp_colorPaletteLabel': 'Түс бояғыштары',
	'radialChartProp_elementColorLabel': 'Радиалды жолық түсі',
	'radialChartProp_hideRadialTitleLabel': 'Тақырыпты жасыру',
	'radialChartProp_hideRadialValueLabel': 'Мәнді жасыру',
	'radialChartProp_maintainAxisScalesLabel': 'Білік өлшемін сақтап қалу',
	'radialChartProp_maintainAxisScalesDescription': 'Біліктерде ең кіші және ең үлкен мәнін әрдайым көрсетіңіз.',
	'radialChartProp_suppressZerosLabel': 'Босты жасыру',
	'radialChartProp_suppressZerosDescription': 'Біріктірілген мәндері жоқ санаттарды жасырыңыз.',
	'pointChart1catCaption': 'Нүкте',
	'pointChart1catDataSlot_valuesLabel': 'Мән',
	'pointChart1catDataSlot_categoriesLabel': 'Ось белгісі',
	'pointChart1catProp_colorPaletteLabel': 'Түс бояғыштары',
	'pointChart1catProp_elementColorLabel': 'Кескін түсі',
	'pointChart1catProp_symbolShapeLabel': 'Нышан кескіні',
	'pointChart1catProp_symbolFillLabel': 'Кескінді толтыру',
	'pointChart1catProp_symbolFillDescription': 'Нышандар үшін толтыру түсін көрсетіңіз.',
	'pointChart1catProp_hideGridLinesLabel': 'Тор сызықтарды жасыру',
	'pointChart1catProp_hideGridLinesDescription': 'Тор сызықтарды жасыру',
	'pointChart1catProp_hideAxisTitleLabelsLabel': 'Ось тақырыбы белгілерін жасыру',
	'pointChart1catProp_hideAxisTitleLabelsDescription': 'Біліктер үшін тақырыптарды жасырыңыз.',
	'pointChart1catProp_maintainAxisScalesLabel': 'Білік өлшемін сақтап қалу',
	'pointChart1catProp_maintainAxisScalesDescription': 'Біліктерде ең кіші және ең үлкен мәнін әрдайым көрсетіңіз.',
	'pointChart1catProp_suppressZerosLabel': 'Босты жасыру',
	'pointChart1catProp_suppressZerosDescription': 'Біріктірілген мәндері жоқ санаттарды жасырыңыз.',
	'scatterPlotChartNoCatCaption': 'Нүктелік сызба',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': 'Көлденең ось',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': 'Тік ось',
	'scatterPlotChartNoCatProp_colorPaletteLabel': 'Түс бояғыштары',
	'scatterPlotChartNoCatProp_elementColorLabel': 'Элемент түсі',
	'scatterPlotChartNoCatProp_symbolShapeLabel': 'Нышан кескіні',
	'scatterPlotChartNoCatProp_symbolFillLabel': 'Кескінді толтыру',
	'scatterPlotChartNoCatProp_symbolFillDescription': 'Нышандар үшін толтыру түсін көрсетіңіз.',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': 'Тор сызықтарды жасыру',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': 'Тор сызықтарды жасыру',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': 'Ось тақырыбы белгілерін жасыру',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': 'Біліктер үшін тақырыптарды жасырыңыз.',
	'radialBarChartCaption': 'Радиалды жолақ',
	'radialBarChartDataSlot_categoriesLabel': 'Санаттар',
	'radialBarChartDataSlot_valuesLabel': 'Мән',
	'radialBarChartProp_colorPaletteLabel': 'Түс бояғыштары',
	'radialBarChartProp_elementColorLabel': 'Радиалды жолық түсі',
	'radialBarChartProp_hideRadialTitleLabel': 'Тақырыпты жасыру',
	'radialBarChartProp_maintainAxisScalesLabel': 'Білік өлшемін сақтап қалу',
	'radialBarChartProp_maintainAxisScalesDescription': 'Біліктерде ең кіші және ең үлкен мәнін әрдайым көрсетіңіз.',
	'radialBarChartProp_suppressZerosLabel': 'Босты жасыру',
	'radialBarChartProp_suppressZerosDescription': 'Біріктірілген мәндері жоқ санаттарды жасырыңыз.',
	'lineColumnComboChartCaption': 'Сызық және баған',
	'lineColumnComboChartDataSlot_categoryLabel': 'Ось белгісі',
	'lineColumnComboChartDataSlot_lineValueLabel': 'Сызық мәні',
	'lineColumnComboChartDataSlot_columnValueLabel': 'Баған мәні',
	'lineColumnComboChartProp_colorPaletteLabel': 'Түс бояғыштары',
	'lineColumnComboChartProp_elementColorLabel': 'Баған түсі',
	'lineColumnComboChartProp_lineColorLabel': 'Сызық және нышан түсі',
	'lineColumnComboChartProp_symbolShapeLabel': 'Нышан кескіні',
	'lineColumnComboChartProp_hideSymbolsLabel': 'Нышандарды жасыру',
	'lineColumnComboChartProp_hideSymbolsDescription': 'Нышандарды жасыру',
	'lineColumnComboChartProp_hideDataLinesLabel': 'Сызық(тар)ды жасыру',
	'lineColumnComboChartProp_hideDataLinesDescription': 'Сызық(тар)ды жасыру',
	'lineColumnComboChartProp_interpolationLabel': 'Тегіс жолдар',
	'lineColumnComboChartProp_interpolationDescription': 'Деректер нүктесін қосатын сызық доғаланған.',
	'lineColumnComboChartProp_hideGridLinesLabel': 'Тор сызықтарды жасыру',
	'lineColumnComboChartProp_hideGridLinesDescription': 'Тор сызықтарды жасыру',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': 'Ось тақырыбы белгілерін жасыру',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': 'Біліктер үшін тақырыптарды жасырыңыз.',
	'lineColumnComboChartProp_maintainAxisScalesLabel': 'Білік өлшемін сақтап қалу',
	'lineColumnComboChartProp_maintainAxisScalesDescription': 'Біліктерде ең кіші және ең үлкен мәнін әрдайым көрсетіңіз.',
	'lineColumnComboChartProp_suppressZerosLabel': 'Босты жасыру',
	'lineColumnComboChartProp_suppressZerosDescription': 'Біріктірілген мәндері жоқ санаттарды жасырыңыз.',
	'lineColumnComboChartProp_hideLegendLabel': 'Мәндік белгілерді жасыру',
	'lineColumnComboChartProp_hideLegendDescription': 'Бұл мәнді белгілерді жасырыңыз.',
	'lineColumnComboChartProp_legendPositionLabel': 'Мәнді белгілер орналасуы',
	'summaryCaption': 'Жиынтық',
	'areaName': 'Аймақ',
	'areaDescription': 'Аймақ',
	'areaDataSlot_colorLabel': 'Түс арқылы',
	'areaDataSlot_valuesLabel': 'Мән',
	'areaDataSlot_categoriesLabel': 'Ось белгісі',
	'bubbleName': 'Көпіршікті',
	'bubbleDescription': 'Көпіршікті',
	'bubbleDataSlot_yAxisLabel': 'Тік ось',
	'bubbleDataSlot_xAxisLabel': 'Көлденең ось',
	'bubbleDataSlot_sizeLabel': 'Өлшем арқылы',
	'bubbleDataSlot_colorLabel': 'Түс арқылы',
	'clusterBarName': 'Тақта',
	'clusterBarDescription': 'Тақта',
	'clusterBarDataSlot_colorLabel': 'Түс арқылы',
	'clusterBarDataSlot_valuesLabel': 'Мән',
	'clusterBarDataSlot_categoriesLabel': 'Ось белгісі',
	'clusterBarDataSlot_valuesRepeatingLabel': 'Мән',
	'clusterColumnName': 'Баған',
	'clusterColumnDescription': 'Баған',
	'clusterColumnDataSlot_colorLabel': 'Түс арқылы',
	'clusterColumnDataSlot_valuesLabel': 'Мән',
	'clusterColumnDataSlot_categoriesLabel': 'Ось белгісі',
	'clusterColumnDataSlot_valuesRepeatingLabel': 'Мән',
	'clusterLineName': 'Жол',
	'clusterLineDescription': 'Жол',
	'clusterLineDataSlot_colorLabel': 'Түс арқылы',
	'clusterLineDataSlot_valuesLabel': 'Тік ось',
	'clusterLineDataSlot_categoriesLabel': 'Көлденең ось',
	'clusterLineDataSlot_valuesRepeatingLabel': 'Мән',
	'gridName': 'Жоғарғы',
	'gridDescription': 'Жоғарғы',
	'gridDataSlot_grid_colsLabel': 'Баған',
	'heatName': 'Қатынасу жиілігі',
	'heatDescription': 'Қатынасу жиілігі',
	'heatDataSlot_yAxisLabel': 'Тік ось',
	'heatDataSlot_xAxisLabel': 'Көлденең ось',
	'heatDataSlot_valuesLabel': 'Қатынасу жиілігі арқылы',
	'lineColumnComboName': 'Сызық және баған',
	'lineColumnComboDescription': 'Сызық және баған',
	'lineColumnComboDataSlot_lineValueLabel': 'Сызық мәні',
	'lineColumnComboDataSlot_categoryLabel': 'Ось белгісі',
	'lineColumnComboDataSlot_columnValueLabel': 'Баған мәні',
	'mapName': 'Бұрынғы карта',
	'mapDescription': 'Бұрынғы карта',
	'mapDataSlot_sizeLabel': 'Нүкте өлшемі',
	'mapDataSlot_valuesLabel': 'Аймақ қатынасу жиілігі',
	'mapDataSlot_sizeHeatLabel': 'Нүкте қатынасу жиілігі',
	'mapDataSlot_categoriesLabel': 'Аймақтар',
	'packedBubbleName': 'Бумаланған көпіршік',
	'packedBubbleDescription': 'Бумаланған көпіршік',
	'packedBubbleDataSlot_sizeLabel': 'Өлшем арқылы',
	'packedBubbleDataSlot_colorLabel': 'Түс арқылы',
	'packedBubbleDataSlot_categoriesLabel': 'Санаттар',
	'pieName': 'Дөңгелек',
	'pieDescription': 'Дөңгелек',
	'pieDataSlot_valuesLabel': 'Мән',
	'pieDataSlot_categoriesLabel': 'Санаттар',
	'playerName': 'Деректер ойнатқышы',
	'playerDescription': 'Деректер ойнатқышы',
	'playerDataSlot_categoriesLabel': 'Ось белгісі',
	'pointName': 'Нүкте',
	'pointDescription': 'Нүкте',
	'pointDataSlot_colorLabel': 'Түс арқылы',
	'pointDataSlot_valuesLabel': 'Мән',
	'pointDataSlot_categoriesLabel': 'Ось белгісі',
	'radialName': 'Радиалды',
	'radialDescription': 'Радиалды',
	'radialDataSlot_valuesLabel': 'Мән',
	'radialDataSlot_maxSizeLabel': 'Ең үлкен мән',
	'radialDataSlot_categoriesLabel': 'Санаттар',
	'radialBarName': 'Радиалды жолақ',
	'radialBarDescription': 'Радиалды жолақ',
	'radialBarDataSlot_valuesLabel': 'Мән',
	'radialBarDataSlot_categoriesLabel': 'Санаттар',
	'scatterPlotName': 'Нүктелік сызба',
	'scatterPlotDescription': 'Нүктелік сызба',
	'scatterPlotDataSlot_yAxisLabel': 'Тік ось',
	'scatterPlotDataSlot_xAxisLabel': 'Көлденең ось',
	'scatterPlotDataSlot_colorLabel': 'Түс арқылы',
	'scatterPlotDataSlot_categoriesLabel': 'Нүктелер',
	'stackedBarName': 'Стек жолағы',
	'stackedBarDescription': 'Стек жолағы',
	'stackedBarDataSlot_colorLabel': 'Түс арқылы',
	'stackedBarDataSlot_valuesLabel': 'Мән',
	'stackedBarDataSlot_categoriesLabel': 'Ось белгісі',
	'stackedBarDataSlot_valuesRepeatingLabel': 'Мән',
	'stackedColumnName': 'Стек бағаны',
	'stackedColumnDescription': 'Стек бағаны',
	'stackedColumnDataSlot_colorLabel': 'Түс арқылы',
	'stackedColumnDataSlot_valuesLabel': 'Мән',
	'stackedColumnDataSlot_categoriesLabel': 'Ось белгісі',
	'stackedColumnDataSlot_valuesRepeatingLabel': 'Мән',
	'summaryChartName': 'Жиынтық',
	'summaryChartDescription': 'Жиынтық',
	'summaryChartDataSlot_valuesLabel': 'Мән',
	'treeMapName': 'Тармақ картасы',
	'treeMapDescription': 'Тармақ картасы',
	'treeMapDataSlot_colorLabel': 'Қатынасу жиілігі арқылы',
	'treeMapDataSlot_valuesLabel': 'Өлшем арқылы',
	'treeMapDataSlot_categoriesLabel': 'Бірінші деңгей',
	'treeMapDataSlot_level3Label': 'Үшінші деңгей',
	'treeMapDataSlot_level2Label': 'Екінші деңгей',
	'wordCloudName': 'Сөз бұлты',
	'wordCloudDescription': 'Сөз бұлты',
	'wordCloudDataSlot_colorLabel': 'Түс арқылы',
	'wordCloudDataSlot_scaleLabel': 'Өлшем арқылы',
	'wordCloudDataSlot_wordLabel': 'Сөздер',
	'treeMap1Cat1MeasureChartCaption': 'Тармақ картасы',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': 'Бірінші деңгей',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': 'Өлшем арқылы',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': 'Түс бояғыштары',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': 'Түс бояғыштары',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': 'Түс бояғыштары',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': 'Түс бояғыштары',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': 'Түс бояғыштары',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': 'Түс бояғыштары',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': 'Білік өлшемін сақтап қалу',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': 'Біліктерде ең кіші және ең үлкен мәнін әрдайым көрсетіңіз.',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': 'Босты жасыру',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': 'Біріктірілген мәндері жоқ санаттарды жасырыңыз.',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': 'Мәндік белгілерді жасыру',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': 'Бұл мәнді белгілерді жасырыңыз.',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': 'Мәнді белгілер орналасуы',
	'wordChart1Cat1MeasureCaption': 'Сөз бұлты',
	'wordChart1Cat1MeasureDataSlot_wordLabel': 'Сөздер',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': 'Өлшем арқылы',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': 'Түс бояғыштары',
	'wordChart1Cat1MeasureProp_elementColorLabel': 'Сөз түсі',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': 'Білік өлшемін сақтап қалу',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': 'Біліктерде ең кіші және ең үлкен мәнін әрдайым көрсетіңіз.',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': 'Босты жасыру',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': 'Біріктірілген мәндері жоқ санаттарды жасырыңыз.',
	'missingDataSetData': 'Бұл деректер жиыны үшін деректер қолжетімсіз келеді. Көзге қатынас үшін әкімшіңізге қатынас орнатыңыз немесе деректер жиыныңызды жаңартыңыз.',
	'hideShowSummaries': 'Жиынтықтарды көрсетуді жасыру',
	'crosstabName': 'Қарсы',
	'value_is_not_available': 'қол жеткізгісіз',
	'swapRowsAndColumns': 'Жолдар мен бағандарды алмастыру',
	'NoPinsCollected': 'Бекітілген көрсетілімдер жоқ',
	'pinSearchOld': 'Менің бекітулерімді іздеу',
	'pinDeletedToast': 'Бекіту жойылды',
	'pinAddedToast': 'Бекіту Менің бектілеріме сәтті қосылды',
	'pinRetrieveError': 'Бір немесе бірнеше бекітулерді шығара алмаймыз. Әрекетті кейінірек қайталаңыз.',
	'pinErrorTitle': 'Бекіту қатесі',
	'pinRemove': 'Бекітуді жою',
	'deletePin': 'Бекітуді жойыңыз',
	'dataset_time': 'уақыт',
	'dataset_date': 'күні',
	'dataset_location': 'орны',
	'dataset_number': 'Сан',
	'dataset_text': 'мәтін',
	'widgetConditionalFormatLabel': 'Шартты пішім басқаруларын ажырата қосу',
	'deletePinConfirmationMessage': 'Осы бекітуді жоюға сенімдісіз бе? Бұл жасалмауы мүмкін емес.',
	'deletePinConfirm': 'Жоюды растау',
	'pinDeleteError': 'Бір немесе бірнеше бекітулерді жоя алмаймыз. Әрекетті кейінірек қайталаңыз.',
	'metadataPickerTitle': 'Дерек жиынын құрыңыз',
	'moreTitle': 'Қосымша',
	'remove_slider_handle': 'Тұтқаны жою',
	'missingFiltering': 'Жоқ баған:',
	'unSupportedPromptType': 'Шақыру сценарийіне қолдау көрсетілмейді.',
	'preAggregateLabel': 'Деректер көзі ішінде жеке мәндерге қолдану',
	'postAggregateLabel': 'Есептегі жол мәндерін қолдану',
	'preAggregateText': 'Ауқым бақылау тақтасының ішінде көрсетілген мәндерді емес, дерек қайнар көзіндегі мәндерді пайдаланады.',
	'tabName_general': 'Жалпы', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visDetails': 'Мәліметтер',
	'tabName_textDetails': 'Мәтін мәліметтері', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_mediaDetails': 'Мультимедиа мәліметері', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_webDetails': 'Веб парақша мәліметтері', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_imageDetails': 'Кескін мәліметтері', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'tabName_visualization': 'Көрнекі бейне',
	'sectionName_canvas': 'Кенеп',
	'sectionName_colorsAndThemes': 'Түс және тақырып',
	'colorsAndThemes_legacyWarning': 'Ағымдағы бақылау тақтасы ертерек шығарылған тақырыпты қолданады. Тақырыпты өзгерту және бақылау тақтасын сақтау алдыңғы тақырып палитраларына қатынасты жояды.',
	'sectionName_details': 'Мәліметтер',
	'sectionName_positionAndStyle': 'Орны & мәнер',
	'sectionName_appearance': 'Пайда болу', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_advanced': 'Кеңейтілген',
	'sectionName_layout': 'Орналасу', // TODO: no longer needed when FF 'PropertiesV2' is enabled
	'sectionName_tabs': 'Қойындылар',
	'sectionName_tabTitle': 'Жапсырма',
	'sectionName_tabBackground': 'Өң',
	'addDataSourceDialogTitle': 'Деректер көзін қосу',
	'addDataSourceDialogButtonLabel': 'Қосу',
	'shapesDoubleChevron': 'Қос бұрышты тырнақша',
	'widgetsPanelTitle': 'Виджеттер',
	'widgetsPanelBasicsTab': 'Негізгілер',
	'widgetsPanelImageLibraryTab': 'Суреттер',
	'widgetsPanelSectionStandard': 'Стандарт',
	'widgetsPanelSectionAdvanced': 'Кеңейтілген',
	'widgetsPanelSectionShapes': 'Пішімдер',
	'customWidgetsTitle': 'Тұтыну виджеттері',
	'filterItemCanvasMove': 'Кенепке қосу',
	'filterOverflowMenu_Global': 'Барлық қойындылардың толып кету мәзірі',
	'filterOverflowMenu_Tab': 'Осы қойындының толып кету мәзірі',
	'filterOverflowMenu_Item': 'Сүзгінің толып кету мәзірі',
	'filterOverflowMenu_Single': 'Толып кету мәзірі',
	'filterItemEdit': 'Сүзгі мәндерін өңдеу',
	'filterDeleteAllItems': 'Барлық сүзгілерді жою',
	'filterClearAllItems': 'Барлық сүзгілерді тазалау',
	'filterClearSelection': 'Сүзгіні тазалау',
	'filterPlayerMode': 'Ойыншыны көрсету',
	'filterStaticMode': 'Тізімді көрсету',
	'filterInvertSelection': 'Сүзгіні оралту',
	'filterIconLabel_Global': 'Барлық қойындылар',
	'filterIconLabel_Single': 'Сүзгілер',
	'filterIconLabel_Tab': 'Бұл қойынды',
	'filterIconTooltip_Global': 'Барлық қойындылар',
	'filterIconTooltip_Tab': 'Бұл қойынды',
	'filterIconTooltip_Single': 'Сүзгілер',
	'filterItemDelete': 'Сүзгіні жою',
	'filterValueSeparator': ',',
	'filterRange': '%{from}-%{to}',
	'filterInvertRange': 'басқасының бәрі: %{from}-%{to}',
	'filterExcept': 'қоспағанда %{values}',
	'filterAll': 'Барлық',
	'filterBlank': '(бос)',
	'filterDisableRangeInvert': 'Бұл баған "Барлық қойындылар" сүзгісінде болған кезде қол жетімді емес.',
	'filterDisableHierarchyInvert': 'Бұл баған иерархиялы сүзгісі ішінде болғанда қолжетімсіз.',
	'filterSelectedOfTotal': '%{totalMembers} қарасты %{selected}',
	'filter_date_before': '%{to} алдында',
	'filter_date_before_except': '%{to}-дан бұрын емес',
	'filter_date_after': '%{from} кейін',
	'filter_date_after_except': '%{from}-дан кейін емес',
	'filter_date_between': '%{from} және %{to} арасында',
	'filter_date_between_except': '%{from}-%{to} арасында емес',
	'filter_drag_and_drop_all_tabs': 'Барлық қойындыларды сүзгілеу үшін деректерді сүйреп апарыңыз.',
	'filter_drag_and_drop_current_tab': 'Қойындыны сүзгілеу үшін деректерді сүйреп апарыңыз.',
	'filter_drag_and_drop_single_dock': 'Сүзгілеу үшін бұл жерге деректерді сүйреп апарыңыз.',
	'errMsgFilterItemGenericTitle': 'Сүзгі мәндері жүктелмейді',
	'widgetChromeRotate': 'Айналдыру',
	'toolbarRegionLabel': 'Құралдар тақтасы',
	'toolbarActionDelete': 'Жою',
	'toolbarActionGroup': 'Топ',
	'toolbarActionUngroup': 'Топтамау',
	'toolbarActionOrderToFront': 'Алдына жіберу',
	'toolbarActionOrderToBack': 'Артқа жіберу',
	'toolbarActionEditTitle': 'Тақырыпты өңдеу',
	'toolbarActionWrapTitle': 'Тақырыпты орап алыңыз',
	'toolbarActionPin': 'Жинау',
	'toolbarActionPinOld': 'Қыстыру',
	'toolbarActionAlign': 'Туралау',
	'alignWidgetLeft': 'Сол',
	'alignWidgetCenter': 'Орталық',
	'alignWidgetRight': 'Оң',
	'alignWidgetTop': 'Үстіңгі',
	'alignWidgetMiddle': 'Ортаңғы',
	'alignWidgetBottom': 'Төменгі',
	'toolbarChangeVisualization': 'Көрнекі бейнелерді өзгертіңіз',
	'multipurposeHeader': 'Виджет түрін таңдаңыз',
	'multipurposePlaceholderText': 'Бастау үшін виджеттердің бірін таңдаңыз.',
	'live_label': 'Диаграмма',
	'filter_label': 'Сүзгі',
	'one_named_live': '%{name} диаграммасы',
	'one_named_live_numbered': '%{name} диаграмма (%{number})',
	'one_unknown_live': 'Диаграмма',
	'one_unknown_live_numbered': 'Диаграмма (%{number})',
	'few_live': '%{count} диаграмма тобы',
	'many_live': '%{count} диаграмма тобы',
	'one_custom': 'Тұтыну виджеті',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': '%{name} сүзгі',
	'one_named_filter_numbered': '%{name} сүзгі (%{number})',
	'one_unknown_filter': 'Сүзгі',
	'one_unknown_filter_numbered': 'Сүзгі (%{number})',
	'few_filter': '%{count} сүзгілер тобы',
	'many_filter': '%{count} сүзгілер тобы',
	'LIVE_bar_has_mapping': '%{values} жолақты диаграмма',
	'LIVE_bar_has_mapping_numbered': '%{values} жолақты диаграмма (%{number})',
	'LIVE_bar_opt_mapping': '%{values} жолақ диаграммасында %{categories}',
	'LIVE_bar_opt_mapping_numbered': '%{values} жолақ диаграммасында %{categories} (%{number})',
	'LIVE_bar_no_mapping': 'Бос гистограмма',
	'LIVE_bar_no_mapping_numbered': 'Бос жолақ диаграммасы (%{number})',
	'LIVE_bar_named': '%{name} жолақты диаграмма',
	'LIVE_bar_named_numbered': '%{name} жолақты диаграмма (%{number})',
	'LIVE_stacked_bar_has_mapping': '%{values} үлестік жолақты диаграмма',
	'LIVE_stacked_bar_has_mapping_numbered': '%{values} stacked bar chart (%{number})',
	'LIVE_stacked_bar_opt_mapping': '%{values} бойынша ВВВВ %{categories} үлестік жолақты диаграмма',
	'LIVE_stacked_bar_opt_mapping_numbered': '%{values} бойынша %{categories} үлестік жолақты диаграмма (%{number})',
	'LIVE_stacked_bar_no_mapping': 'Бос жинақталған гистограмма',
	'LIVE_stacked_bar_no_mapping_numbered': 'Бос үлестік жолақты диаграммасы (%{number})',
	'LIVE_stacked_bar_named': '%{name} үлестік жолақты диаграмма',
	'LIVE_stacked_bar_named_numbered': '%{name} stacked bar chart (%{number})',
	'LIVE_bubble_has_mapping': '%{x} және %{y} көпіршікті диаграммасы бойынша %{categories}',
	'LIVE_bubble_has_mapping_numbered': '%{x} және  %{y} көпіршікті диаграммасы бойынша %{categories} (%{number})',
	'LIVE_bubble_no_mapping': 'Бос көпіршікті диаграмма',
	'LIVE_bubble_no_mapping_numbered': 'Бос көпіршікті диаграмма (%{number})',
	'LIVE_bubble_named': '%{name} көпіршікті диаграмма',
	'LIVE_bubble_named_numbered': '%{name} көпіршікті диаграмма (%{number})',
	'LIVE_composite_has_mapping': '%{columnValue} және %{lineValue} бойынша %{categories} құрама диаграмма',
	'LIVE_composite_has_mapping_numbered': '%{columnValue} және %{lineValue} бойынша %{categories} құрама диаграмма (%{number})',
	'LIVE_composite_no_mapping': 'Бос құрама диаграмма',
	'LIVE_composite_no_mapping_numbered': 'Бос құрама диаграмма (%{number})',
	'LIVE_composite_named': '%{name} құрама диаграмма',
	'LIVE_composite_named_numbered': '%{name} құрама диаграмма (%{number})',
	'LIVE_decision_tree_has_mapping': '%{values} шешім ағашы',
	'LIVE_decision_tree_has_mapping_numbered': '%{values} шешім ағашы (%{number})',
	'LIVE_decision_tree_no_mapping': 'Бос шешімдер ағашы',
	'LIVE_decision_tree_no_mapping_numbered': 'Бос шешім ағашы (%{number})',
	'LIVE_decision_tree_named': '%{name} шешім ағашы',
	'LIVE_decision_tree_named_numbered': '%{name} шешім ағашы (%{number})',
	'LIVE_packed_bubble_has_mapping': '%{categories} бумаланған көпіршікті диаграмма',
	'LIVE_packed_bubble_has_mapping_numbered': '%{categories} бумаланған көпіршікті диаграмма (%{number})',
	'LIVE_packed_bubble_no_mapping': 'Бос қапталған көпіршікті диаграмма',
	'LIVE_packed_bubble_no_mapping_numbered': 'Бос бумаланған көпіршікті диаграмма (%{number})',
	'LIVE_packed_bubble_named': '%{name} бумаланған көпіршікті диаграмма',
	'LIVE_packed_bubble_named_numbered': '%{name} бумаланған көпіршікті диаграмма (%{number})',
	'LIVE_pie_has_mapping': '%{values} бойынша %{categories}- дөңгелек диаграммасы',
	'LIVE_pie_has_mapping_numbered': '%{values} бойынша %{categories} дөңгелек диаграммасы (%{number})',
	'LIVE_pie_no_mapping': 'Бос дөңгелек диаграмма',
	'LIVE_pie_no_mapping_numbered': 'Бос дөңгелек диаграммасы (%{number})',
	'LIVE_pie_named': '%{name} дөңгелек диаграммасы',
	'LIVE_pie_named_numbered': '%{name} дөңгелек диаграммасы (%{number})',
	'LIVE_pie_as_donut_has_mapping': '%{values} арқылы %{categories} сақиналы диаграммалар',
	'LIVE_pie_as_donut_has_mapping_numbered': '%{values} бойынша %{categories} сақиналы диаграммасы (%{number})',
	'LIVE_pie_as_donut_no_mapping': 'Бос сақина диаграмма',
	'LIVE_pie_as_donut_no_mapping_numbered': 'Бос сақиналы диаграммасы (%{number})',
	'LIVE_pie_as_donut_named': '%{name} сақиналы диаграммасы',
	'LIVE_pie_as_donut_named_numbered': '%{name} сақиналы диаграммасы (%{number})',
	'LIVE_line_has_mapping': '%{values} бойынша %{categories} сызықтық диаграмма',
	'LIVE_line_has_mapping_numbered': '%{values} бойынша %{categories} сызықтық диаграмма (%{number})',
	'LIVE_line_no_mapping': 'Бос сызықтық диаграмма',
	'LIVE_line_no_mapping_numbered': 'Бос сызықтық диаграмма (%{number})',
	'LIVE_line_named': '%{name} сызықтық диаграмма',
	'LIVE_line_named_numbered': '%{name} сызықтық диаграмма (%{number})',
	'LIVE_area_has_mapping': '%{values} бойынша %{categories} аумақтық диаграмма',
	'LIVE_area_has_mapping_numbered': '%{values} бойынша %{categories} аумақтық диаграмма (%{number})',
	'LIVE_area_no_mapping': 'Бос аумақтық диаграмма',
	'LIVE_area_no_mapping_numbered': 'Бос аумақтық диаграмма (%{number})',
	'LIVE_area_named': '%{name} аумақтық диаграмма',
	'LIVE_area_named_numbered': '%{name} аумақтық диаграмма (%{number})',
	'LIVE_area_as_stacked_percent_has_mapping': '%{values} бойынша %{categories}  аумақтық Қатталған пайыздық диаграмма',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': '%{values} бойынша %{categories} аумақтық қатталған пайыздық диаграмма (%{number})',
	'LIVE_area_as_stacked_percent_no_mapping': 'Бос жинақталған пайыз аумақтық диаграмма',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': 'Бос аумақтық қатталған пайыздық диаграмма (%{number})',
	'LIVE_area_as_stacked_percent_named': '%{name} аумақтық қатталған пайыздық диаграмма',
	'LIVE_area_as_stacked_percent_named_numbered': '%{name} аумақтық қатталған пайыздық диаграмма (%{number})',
	'LIVE_heatmap_has_mapping': '%{color} жылу картасы',
	'LIVE_heatmap_has_mapping_numbered': '%{color} жылу картасы (%{number})',
	'LIVE_heatmap_no_mapping': 'Бос жылу картасы',
	'LIVE_heatmap_no_mapping_numbered': 'Бос жылу картасы (%{number})',
	'LIVE_heatmap_named': '%{name} жылу картасы',
	'LIVE_heatmap_named_numbered': '%{name} жылу картасы (%{number})',
	'LIVE_network_opt_mapping': '%{series} және %{values} бойынша %{categories} желісі',
	'LIVE_network_opt_mapping_numbered': '%{series} және %{values} бойынша %{categories} желісі (%{number})',
	'LIVE_network_has_mapping': '%{series} бойынша %{categories} желісі',
	'LIVE_network_has_mapping_numbered': '%{series} бойынша %{categories} желісі (%{number})',
	'LIVE_network_no_mapping': 'Бос желі',
	'LIVE_network_no_mapping_numbered': 'Бос желі (%{number})',
	'LIVE_network_named': '%{name} желі',
	'LIVE_network_named_numbered': '%{name} желі (%{number})',
	'LIVE_radial_bar_opt_mapping': '%{values} бойынша %{categories}радиалды жолақты диаграмма',
	'LIVE_radial_bar_opt_mapping_numbered': '%{values} бойынша %{categories} радиалды жолақты диаграмма (%{number})',
	'LIVE_radial_bar_has_mapping': '%{values} радиалды жолақты диаграмма',
	'LIVE_radial_bar_has_mapping_numbered': '%{values} радиалды жолақты диаграмма (%{number})',
	'LIVE_radial_bar_no_mapping': 'Бос радиалды гистограмма',
	'LIVE_radial_bar_no_mapping_numbered': 'Бос радиалды жолақты диаграмма (%{number})',
	'LIVE_radial_bar_named': '%{name} радиалды жолақты диаграмма',
	'LIVE_radial_bar_named_numbered': '%{name} радиалды жолақты диаграмма (%{number})',
	'LIVE_spiral_has_mapping': '%{values} спиралды диаграммасы',
	'LIVE_spiral_has_mapping_numbered': '%{values} спиралды диаграммасы (%{number})',
	'LIVE_spiral_no_mapping': 'Бос орамдық диаграмма',
	'LIVE_spiral_no_mapping_numbered': 'Бос спиралды диаграммасы (%{number})',
	'LIVE_spiral_named': '%{name} спиралды диаграммасы',
	'LIVE_spiral_named_numbered': '%{name} спиралды диаграммасы (%{number})',
	'LIVE_treemap_has_mapping': '%{size} бойынша %{categories} ағаш картасы',
	'LIVE_treemap_has_mapping_numbered': '%{size} бойынша %{categories} ағаш картасы (%{number})',
	'LIVE_treemap_no_mapping': 'Бос ағаш картасы',
	'LIVE_treemap_no_mapping_numbered': 'Бос ағаш картасы (%{number})',
	'LIVE_treemap_named': '%{name} ағаш картасы',
	'LIVE_treemap_named_numbered': '%{name} ағаш картасы (%{number})',
	'LIVE_wordcloud_has_mapping': '%{categories} сөз бұлты',
	'LIVE_wordcloud_has_mapping_numbered': '%{categories} сөз бұлты (%{number})',
	'LIVE_wordcloud_no_mapping': 'Бос сөз бұлтты',
	'LIVE_wordcloud_no_mapping_numbered': 'Бос сөз бұлты (%{number})',
	'LIVE_wordcloud_named': '%{name} сөз бұлты',
	'LIVE_wordcloud_named_numbered': '%{name} сөз бұлты (%{number})',
	'LIVE_data_player_has_mapping': '%{category} деректер ойнатқышы',
	'LIVE_data_player_has_mapping_numbered': '%{category} деректер ойнатқышы (%{number})',
	'LIVE_data_player_no_mapping': 'Бос дерек ойнатқышы',
	'LIVE_data_player_no_mapping_numbered': 'Бос деректер ойнатқышы (%{number})',
	'LIVE_data_player_named': '%{name} деректер ойнатқышы',
	'LIVE_data_player_named_numbered': '%{name} деректер ойнатқышы (%{number})',
	'LIVE_map_has_mapping': '%{locations}карта',
	'LIVE_map_has_mapping_numbered': '%{locations} карта (%{number})',
	'LIVE_map_no_mapping': 'Бос карта',
	'LIVE_map_no_mapping_numbered': 'Бос карта (%{number})',
	'LIVE_map_named': '%{name}карта',
	'LIVE_map_named_numbered': '%{name} карта (%{number})',
	'LIVE_point_has_mapping': '%{values} бойынша %{categories} нүктелік диаграмма',
	'LIVE_point_has_mapping_numbered': '%{values} бойынша %{categories} нүктелік диаграмма (%{number})',
	'LIVE_point_no_mapping': 'Бос нүктелік кесте',
	'LIVE_point_no_mapping_numbered': 'Бос нүктелік диаграмма (%{number})',
	'LIVE_point_named': '%{name} нүктелік диаграмма',
	'LIVE_point_named_numbered': '%{name} нүктелік диаграмма (%{number})',
	'LIVE_column_has_mapping': '%{values} баған диаграммасы',
	'LIVE_column_has_mapping_numbered': '%{values} баған диаграммасы (%{number})',
	'LIVE_column_opt_mapping': '%{values} бойынша %{categories} баған диаграммасы',
	'LIVE_column_opt_mapping_numbered': '%{values} бойынша %{categories} баған диаграммасы (%{number})',
	'LIVE_column_no_mapping': 'Бос бағанды кестесі',
	'LIVE_column_no_mapping_numbered': 'Бос баған диаграммасы (%{number})',
	'LIVE_column_named': '%{name} баған диаграммасы',
	'LIVE_column_named_numbered': '%{name} баған диаграммасы (%{number})',
	'LIVE_stacked_column_has_mapping': '%{values} үлестік баған диаграммасы',
	'LIVE_stacked_column_has_mapping_numbered': '%{values} үлестік баған диаграммасы (%{number})',
	'LIVE_stacked_column_opt_mapping': '%{values} бойынша %{categories} үлестік баған диаграммасы',
	'LIVE_stacked_column_opt_mapping_numbered': '%{values} бойынша %{categories} үлестік баған диаграммасы (%{number})',
	'LIVE_stacked_column_no_mapping': 'Бос қойылған бағандар кестесі',
	'LIVE_stacked_column_no_mapping_numbered': 'Бос үлестік баған диаграммасы (%{number})',
	'LIVE_stacked_column_named': '%{name} үлестік баған диаграммасы',
	'LIVE_stacked_column_named_numbered': '%{name} үлестік баған диаграммасы (%{number})',
	'LIVE_scatter_opt_mapping': '%{x} және %{y} бойынша %{categories} нүктелік тұрғызу',
	'LIVE_scatter_opt_mapping_numbered': '%{x} және %{y} бойынша %{categories} нүктелік тұрғызу (%{number})',
	'LIVE_scatter_has_mapping': '%{x} қарсы %{y} нүктелік тұрғызу',
	'LIVE_scatter_has_mapping_numbered': '%{x} қарсы %{y} шашыраңқы диаграмма (%{number})',
	'LIVE_scatter_no_mapping': 'Бос шашылу диаграмма',
	'LIVE_scatter_no_mapping_numbered': 'Бос шашыраңқы диаграмма (%{number})',
	'LIVE_scatter_named': '%{name} шашыраңқы диаграмма',
	'LIVE_scatter_named_numbered': '%{name} шашыраңқы диаграмма (%{number})',
	'LIVE_waterfall_has_mapping': '%{values} сарқырама диаграммасы',
	'LIVE_waterfall_has_mapping_numbered': '%{values} сарқырама диаграммасы (%{number})',
	'LIVE_waterfall_no_mapping': 'Бос сарқырама кестесі',
	'LIVE_waterfall_no_mapping_numbered': 'Бос сарқырама диаграммасы (%{number})',
	'LIVE_waterfall_named': '%{name} сарқырама диаграммасы',
	'LIVE_waterfall_named_numbered': '%{name} сарқырама диаграммасы (%{number})',
	'LIVE_empty_visualization_hint_title': 'Көрнекілігіңізді құру',
	'LIVE_empty_visualization_hint_description': 'Бағандарды осы жерге немесе слоттарды солға қарай сүйреп апарыңыз.',
	'LIVE_slots_required_field_description': '%{asterisk} Қажетті өрісті көрсетеді',
	'LIVE_slots_drag_and_drop_description': 'Көрнекілікті сүзгілеу және құру үшін слоттарға деректерді сүйреп апарып тастаңыз.',
	'requiredField': 'Қажетті өріс',
	'fullScreenEnter': 'Толық экран режиміне ену',
	'fullScreenClose': 'Толық экран режимінен шығу',
	'noExtraText_multipurpose': 'Көпмақсатты толтырғыш',
	'noExtraText_multipurpose_numbered': 'Көп мақсатты толтырғыш (%{number})',
	'one_placeholder_vis': 'Көрнекілендіру толтырғышы',
	'one_placeholder_vis_numbered': 'Көрнекіліктің толтырғышы (%{number})',
	'one_placeholder_text': 'Мәтіндік толтырғыш',
	'one_placeholder_text_numbered': 'Мәтінді толтырғыш (%{number})',
	'few_placeholder_text': '%{count} Мәтінді толтырғыштар тобы',
	'many_placeholder_text': '%{count} Мәтінді толтырғыштар тобы',
	'filter_includesAll': 'Барлығын қамтиды',
	'timeline_filter_moved_to': 'Уақыт сызығының сүзгісі %{id} %{time}-ге ауысты',
	'timelineSettingsButton': 'Ойнату параметрлері',
	'autoPlay': 'Барлық көріністерді ойнатыңыз',
	'loop': 'Цикл',
	'noSceneTransitionLabel': 'Ешбір',
	'sceneTransitionPropertyLabel': 'Көрініс өтуі',
	'animatedPathSceneTransitionLabel': 'Анимацияланған жол',
	'sweepSceneTransitionLabel': 'Бұрылу',
	'propAniAnimation': 'Анимация',
	'propAniTypeEntrance': 'Кіру анимациясы',
	'propAniDirectionIn': 'Кіру бағыты',
	'propAniTypeExit': 'Анимациядан шығу',
	'propAniDirectionOut': 'Бағыттан шығу',
	'propAniDirection': 'Бағыт',
	'timelineAnimationProperties': 'Анимация сипаттарын ашу',
	'editStoryCoachMarkTitle': 'Өңдеу мәтіндік бөлігі',
	'editStoryCoachMarkContents': 'Бұл мәтіндік бөлікті өңдеуге қаламсап белгішесін басыңыз.',
	'addDataStoryCoachMarkContents': 'Мәтіндік бөлікке деректер тақтасынан деректерді апарып салыңыз.',
	'expandSceneCoachmarkTitle': 'Уақыт шкаласын ашу',
	'expandSceneCoachmarkContents': 'Уақыт және ұзақтығына негізделген нысан көрінісін реттеу арқылы көріністі жандандырыңыз.',
	'overviewCoachmarkTitle': 'Көріністерді шолу',
	'overviewCoachmarkContents': 'Жалпы көріністі көрсету үшін көріністерді шолуыны оқиғаңыздың басында және аяғында пайдаланыңыз. Көріністерді шолудан басқа көріністермен ауыстыру үшін оны басыңыз және сүйреңіз. Көріністер шолуыны оқіға сипаттарында көрсете немесе жасыра аласыз.',
	'animatedPathCoachmarkTitle': 'Анимацияланған жол',
	'animatedPathCoachmarkContents': 'Нысаны бар көріністі көшірмелеу арқылы бір көріністен өзгесіне нысан анимациясын жасаңыз. Содан кейін, жаңа көріністе көшірілген нысанды жылжытыңыз, өлшемін өзгертіңіз немесе айналдырыңыз.',
	'tabName_animation': 'Анимация',
	'textWidgetIconPlaceholderText': 'Мәтін қосу үшін басыңыз',
	'buildVisHeader': 'Көрнекілендіруді жасау',
	'visIconPlaceholderText': 'Көрнекілік құру үшін өрістерді сүйреп апарыңыз',
	'launchNewExplore': 'Жаңа зерттеу',
	'addTo': 'Келесіге қосу',
	'addToExisting': 'Қолданыстағыға қосу...',
	'exploreData': 'Зерттеу',
	'explore_remove_widget_styles': 'Түс параметрлері сияқты теңшелетін көрнекілендіру сипаттары сіздің зерттеуңізде сақталмайды.',
	'editNotebook': 'Виджетті өңдеу',
	'thumbnails_error_fetching': 'Эскиздерді алу қатесі',
	'copy': '%{count} активтері көшірілді',
	'specConvertErr': 'Бақылау тақтасының сипаттамасын қою немесе түрлендіруде қате орын алды',
	'specCopyErr': 'Басқару тақтасының ерекшеліктерін көшіру кезінде қате орын алды',
	'pasteNotSupportedErr': '%{name}-дан қоюға қолдау көрсетілмейді.',
	'reportParam': 'есеп',
	'filterWidgetCopyWarn': 'Сүзгі көрнекілендіруі осы уақытта Сүзгілерге қолдау көрсетілмегендіктен көшірілмеді.',
	'upgradingDashboard': '"%{name}"-ны %{version}-ға жаңарту...',
	'upgradeComplete': 'Жаңарту аяқталды',
	'individualTabProperties': 'Жеке қойынды сипаттары',
	'propMasterTabStylesLabel': 'Шеберге арналған сәндеу',
	'propTabPosition': 'Қойынды орны',
	'propTabTitle': 'Тақырып',
	'propTabBackgroundColor': 'Түспен толтыру',
	'propTabTextColor': 'Тақырып түсі',
	'propTabSelectedBarColor': 'Таңдалған жолақ түсі',
	'propTabRestoreDefaults': 'Әдепкі параметрлерді қайта сақтау',
	'propIndividualTabStylesLabel': 'Жеке ойыншықтарды сәндеу',
	'propIndividualTabStylesAriaLabel': 'Жеке ойыншықтарды мәнерлеу',
	'propTabIconPosition': 'Белгішенің орналасуы',
	'propLeftTitle': 'Тақырыптың сол жағы',
	'propRightTitle': 'Тақырыптың оң жағы',
	'propTopTitle': 'Тақырыптың жоғары',
	'propBottomTitle': 'Тақырыптың астында',
	'propTabIconLabel': 'Көрнекі',
	'propTabIcon': 'Белгіше',
	'propTabIconColor': 'Белгіше түсі',
	'no_icon': 'Бос',
	'announcement': 'Хабарландыру',
	'api': 'Api',
	'archive': 'Мұрағат',
	'asset': 'Актив',
	'attachment': 'Тіркелгі',
	'audio': 'Аудио',
	'bee': 'Bee',
	'blog': 'Блог',
	'bookmark': 'Бетбелгі',
	'calendar': 'Күнтізбе',
	'camera': 'Камера',
	'capability': 'Мүмкіндік',
	'catalog': 'Каталог',
	'chat_message': 'Чат хабарламасы',
	'checkout_cart': 'Тапсырыс беріңіз',
	'client': 'Клиент',
	'clock': 'Сағат',
	'cloud': 'Бұлт',
	'code': 'Коды',
	'data_quality': 'Деректер сапасы',
	'folder': 'Қалталар',
	'forum': 'Форум',
	'glasses': 'Сыныптар',
	'group': 'Топ',
	'hat': 'Бас киім',
	'headphone': 'Құлаққап',
	'hills': 'Төбелер',
	'home': 'Басты',
	'idea': 'Идея',
	'image': 'Кескін',
	'inventory': 'Тізім',
	'like': 'Ұнайды',
	'link': 'Сілтеме',
	'location': 'Орны',
	'manage': 'Басқару',
	'pen': 'Қалам',
	'mobile_phone': 'Ұялы телефон',
	'music': 'Музыка',
	'notifications': 'Хабарландырулар',
	'paint': 'Бояу',
	'payment': 'Төлем',
	'password_key': 'Құпия кілті',
	'people': 'Адамдар',
	'person': 'Кісі',
	'phone': 'Телефон',
	'pin': 'Қыстыру',
	'print': 'Басып шығару',
	'recording': 'Жазу',
	'repository': 'Репозиторий',
	'role': 'Рөл',
	'search': 'Іздеу',
	'properties': 'Сипаттар',
	'speaker': 'Үндеткіш',
	'star': 'Жұлдыз',
	'tag': 'Тег',
	'thumbs_up': 'Жарайсың',
	'thumbs_down': 'Жарамайды',
	'tools': 'Құралдар',
	'traffic': 'Трафик',
	'trash': 'Қоқыс',
	'twitter': 'Twitter',
	'unknown': 'Белгісіз',
	'user': 'Пайдаланушы',
	'venn_diagram': 'Венн диаграммасы',
	'video': 'Бейне',
	'view': 'Көрініс',
	'warning': 'Ескерту',
	'watch': 'Қарау',
	'watson': 'Ватсон',
	'wikis': 'Вики беттер',
	'workspace': 'Жұмыс кеңістігі',
	'world': 'Әлем',
	'OnLoadFilterModifierDatasourceMismatch': 'Сүзгілер нысанаға қолданылмайды, өйткені бақылау тақталарында әртүрлі көздер қолданылады.',
	'OnLoadFilterModifierColumnMismatch': 'Бір немесе бірнеше сүзгілер қолданылмады, өйткені сәйкес баған (дар) табылмады.',
	'eventGroupButtonLabel': 'Виджет қосылымдарын көріңіз',
	'dockToolbar': 'Бекітілетін құралдар тақтасы',
	'undockToolbar': 'Ажырату құралдар тақтасы',
	'propShowTitle': 'Тақырыпты көрсету'
});
